import { Injectable, inject } from '@angular/core';

import { DbContext } from '../../core/utils/db-context';
import { Tools } from '../../core/utils/tools/index';
import { BaseEntityRepository } from '../../core/abstractions/base-entity.repository';
import { RepositoriesConfig } from '../../core/utils/repositories.config';
import { FailedRequestModel } from '../../models/failed-request.model';
import { RequestService } from '../request.service';
import { RepositoryService } from '../repository.service';

@Injectable({
    providedIn: 'root'
})
export class FailedRequestsRepository extends BaseEntityRepository<FailedRequestModel> {
    private requestService = inject(RequestService);

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);

    constructor() {
        const repositoryService = inject(RepositoryService);

        super(repositoryService);
        this.config = RepositoriesConfig.repositories.find(r => r.tableName === DbContext.FailedRequests);
    }

    saveRequest(urlWithParams: string, method: string, body: any): void {
        // in case the sync method fails, this method will be
        // invoked again. to prevent duplications of the very same object in localDb,
        // we add a custom property (clientId), and simply return before save
        if (body.hasOwnProperty('clientId')) {
            return;
        }

        if (body.hasOwnProperty('description')) {
            body.description = `${body.description} (auto-sync)`;
        }

        const customId = Tools.Utils.generateGuid();
        body.clientId = customId;

        this.add(new FailedRequestModel({
            id: customId,
            clientId: customId,
            url: urlWithParams,
            method,
            body: JSON.stringify(body)
        }));
    }

    retry(item: FailedRequestModel): void {
        this.requestService.replayRequest(item.url, item.method, item.body).subscribe();
    }
}
